import { ShieldAlert } from "lucide-react";

export const PROGRAM_LABELS = {
  weight_loss: "Weight Loss",
  performance: "Performance",
  longevity: "Longevity",
};

export const Disclaimer = ({ className = "" }) => (
  <div className={`flex items-start gap-2 text-[11px] text-slate-400 leading-relaxed ${className}`} data-testid="program-disclaimer">
    <ShieldAlert size={14} className="text-amber-400/80 mt-0.5 shrink-0" />
    <span>Wellness, fitness &amp; lifestyle guidance from the CG Labz Performance Team — not medical advice or diagnosis, and no peptide dosing. Consult your doctor before starting to confirm it&apos;s right for you.</span>
  </div>
);

export const CoachBadge = ({ coach = "Chris Goss" }) => (
  <div className="flex items-center gap-2.5" data-testid="coach-badge">
    <div className="w-9 h-9 rounded-full bg-gradient-to-br from-cyan-400/30 to-cyan-600/10 border border-cyan-400/30 flex items-center justify-center font-serif text-cyan-200 text-sm">
      {coach.split(" ").map((w) => w[0]).join("")}
    </div>
    <div className="leading-tight">
      <div className="text-sm text-white">{coach}</div>
      <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">CG Labz Performance Team</div>
    </div>
  </div>
);

export const Ring = ({ pct = 0, size = 56, label }) => {
  const r = (size - 7) / 2;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} strokeWidth="5" className="stroke-white/15" fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} strokeWidth="5" className="stroke-cyan-400" fill="none"
          strokeDasharray={c} strokeDashoffset={c - (pct / 100) * c} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease", filter: "drop-shadow(0 0 4px rgba(34,211,238,0.6))" }} />
      </svg>
      <span className="absolute font-mono text-sm font-semibold text-white">{label ?? `${pct}%`}</span>
    </div>
  );
};
